<template>
  <div class="tourHotelSelectHotel_card-hotel_info_detail_price">
    <div class="tourHotelSelectHotel_card-hotel_info_detail_price_stay">
      {{ displayPriceText }}
    </div>
    <template v-if="isGoto">
      <div class="tourHotelSelectHotel_card-hotel_info_detail_price_block1">
        <div class="tourHotelSelectHotel_card-hotel_info_detail_price_cur">
          <p class="tag">支払実額</p>
          <p class="price">{{ gotoPrice }}</p>
        </div>
      </div>
      <div class="tourHotelSelectHotel_card-hotel_info_detail_price_block2">
        <div class="tourHotelSelectHotel_card-hotel_info_detail_price_cur">
          <p class="tag">旅行代金</p>
          <p class="price">{{ currentPrice }}</p>
        </div>
        <div
          v-if="previousPrice && previousPrice.length"
          class="tourHotelSelectHotel_card-hotel_info_detail_price_cur2"
        >
          {{ previousPrice }}
        </div>
      </div>
    </template>
    <template v-else>
      <div class="tourHotelSelectHotel_card-hotel_info_detail_price_block1">
        <div class="tourHotelSelectHotel_card-hotel_info_detail_price_cur">
          <p class="price">{{ currentPrice }}</p>
        </div>
      </div>
      <div
        v-if="previousPrice && previousPrice.length"
        class="tourHotelSelectHotel_card-hotel_info_detail_price_block2"
      >
        <div class="tourHotelSelectHotel_card-hotel_info_detail_price_cur2">
          {{ previousPrice }}
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  name: 'HotelCardPrice',
  props: {
    passengerNumber: { type: Number, required: true },
    nightNumber: { type: Number, required: true },
    isGoto: { type: Boolean, required: true },
    currentPrice: { type: String, required: true },
    gotoPrice: { type: String, default: '' },
    previousPrice: { type: String, default: '' },
    isTourFree: { type: Boolean, default: false },
  },
  computed: {
    displayPriceText() {
      if (
        this.isTourFree ||
        (this.passengerNumber === 1 && this.nightNumber === 1)
      ) {
        return '1名あたりの料金'
      }
      return `${this.passengerNumber}名${this.nightNumber}泊合計`
    },
  },
}
</script>
